<template>
  <div
    v-if="showField"
    class="query__expansion-field-container"
  >
    <span class="query__expansion-field-label">{{ props.fieldName }}:</span>
    <span
      v-if="props.fieldType === 'string'"
      class="query__expansion-field-value"
    >
      {{ props.fieldValue }}
    </span>
    <span
      v-if="props.fieldType === 'bool' && props.fieldValue"
      class="query__expansion-field-value"
    >
      Sí
    </span>
    <span
      v-if="props.fieldType === 'bool' && !props.fieldValue"
      class="query__expansion-field-value"
    >
      No
    </span>
  </div>
</template>

<script setup>
import {computed} from 'vue';
// #region Props, Emits
const props = defineProps({
  fieldName: {
    type: String,
    required: true,
  },
  fieldValue: {
    type: String,
    required: true,
  },
  fieldType: {
    type: String,
    default: () => 'string',
  },
});
// #endregion

// #region Params, Ref, Reactives, Computed
const showField = computed(() => {
  if (props.fieldType === 'string' && !!props.fieldValue) {
    return true;
  }
  if (props.fieldType === 'bool' && props.fieldValue != null) {
    return true;
  }
  return false;
});
// #endregion

// #region Functions

// #endregion

// #region Effects, Hooks

// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped></style>
